export const QCPAGES = ['qcmetrics', 'qcnetstatissues'];
export const QC_COLORS = ['#ffffff', '#ffe6ff', '#e6f7ff', '#ffffe6'];

